// extracted by mini-css-extract-plugin
export default {"mainWrapper":"products_mainWrapper__MZJ7V","taskChipWrapper":"products_taskChipWrapper__CRRTw"};